import { useTranslation } from "react-i18next";
import {useState, useEffect, useContext} from "react";
import {useDispatch, useSelector} from "react-redux";
import DelimiterInput from "../DelimiterInput";
import {treeActions} from "../../../redux/slices/treeSlice";
import GroupByName from "../GroupByName";
import TPCheckbox from '../TPCheckbox';
import { Stack } from "@mui/material";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import OverrideInboundDelimeter from "../OverrideInboundDelimeter";

export default function DelimitedForm() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [recordDelimiter, setRecordDelimiter] = useState(false);
  const [fieldDelimiter, setFieldDelimiter] = useState(false);
  const [stripQuotes, setStripQuotes] = useState(false);
  const [trimData, setTrimData] = useState(false);
  const [decodeData, setDecodeData] = useState(false);
  const [lenientRecord, setLenientRecord] = useState(false);
  const [groupRecord, setGroupRecord] = useState('');
  const [groupField, setGroupField] = useState('');

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setRecordDelimiter(header.LINEDELIMITER || '');
    setFieldDelimiter(header.DELIMITER || '');
    setLenientRecord(
      header.LENIENT_RECORD_DELIMITER ?
        (typeof header.LENIENT_RECORD_DELIMITER === 'boolean' && header.LENIENT_RECORD_DELIMITER) || header.LENIENT_RECORD_DELIMITER === "TRUE" || false
        : false
    );
    setStripQuotes(
      header.UNCSV ?
        (typeof header.UNCSV === 'boolean' && header.UNCSV) || header.UNCSV === "TRUE" || false
        : false
    );
    setTrimData(
      header.TRIMDATA ?
        (typeof header.TRIMDATA === 'boolean' && header.TRIMDATA) || header.TRIMDATA === "TRUE" || false
        : false
    );
    setDecodeData(
      header.URLDECODE ?
        (typeof header.URLDECODE === 'boolean' && header.URLDECODE) || header.URLDECODE === "TRUE" || false
        : false
    );
    setGroupRecord(header.GROUP_RECORD_TYPE || '');
    setGroupField(header.GROUP_MAPNAME || '');
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }
  return (
    <>
      <>
        <DelimiterInput
          default
          label={t('LBL_REC_DELIM')}
          value={recordDelimiter}
          name={'LINEDELIMITER'}
        />
        <DelimiterInput
          default
          label={t('LBL_FLD_DELIM')}
          value={fieldDelimiter}
          name={'DELIMITER'}
        />
      </>
      
      {parentScreen === 'inbound' && <>
      <div className="flex flex-wrap">
        <TPCheckbox 
          label={t('BTN_LENIENT_RECORD_DEL')}
          checked={lenientRecord}
          handleCheck={(checked) => {
            setStripQuotes(checked);
            handleChange('LENIENT_RECORD_DELIMITER', checked);
          }}
        />
        <TPCheckbox 
          label={t('BTN_STRIP_QUOTES')}
          checked={stripQuotes}
          handleCheck={(checked) => {
            setStripQuotes(checked);
            handleChange('UNCSV', checked);
          }}
        />
        <TPCheckbox 
          label={t('BTN_TRIM_DATA')}
          checked={trimData}
          handleCheck={(checked) => {
            setTrimData(checked);
            handleChange('TRIMDATA', checked);
          }}
        />
        <TPCheckbox 
          label={t('BTN_URLDECODE_DATA')}
          checked={decodeData}
          handleCheck={(checked) => {
            setDecodeData(checked);
            handleChange('URLDECODE', checked);
          }}
        />
      </div>
      <GroupByName /> </>}

      {parentScreen === 'outbound' && <OverrideInboundDelimeter/>}
    </>
  )
}
